var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
import { BaseDialogState } from "../UIComponents/BaseDialog";
export class MessageReadDialogState {
    constructor() {
        this.messageid = "";
        this.letrid = "";
        this.messagereadtime = [];
        this.loading = false;
        this.baseDialogState = new BaseDialogState();
        makeObservable(this);
        this.baseDialogState.setHideFooter(true);
        this.baseDialogState.setHeaderLabel("Read receipt");
        APPEvent.addSubscriberForMessageReadTime((res) => {
            if (res.letrid === this.letrid && res.messageid === this.messageid) {
                this.messagereadtime = res.readtime;
                this.setLoading(false);
            }
        });
    }
    setLoading(loading) {
        this.loading = loading;
    }
    setShow(show) {
        this.baseDialogState.setOpen(show);
    }
    getMessageRead() {
        this.setLoading(true);
        const req = {
            messageid: this.messageid,
            letrid: this.letrid
        };
        Apphandler.sendMessage("messagereadtime", req);
    }
    reset() {
        this.letrid = "";
        this.messageid = "";
        this.setLoading(false);
        this.messagereadtime = [];
        this.setShow(false);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], MessageReadDialogState.prototype, "loading", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MessageReadDialogState.prototype, "setLoading", null);
